import { $, _, Radio, Foundation, moment } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import InboomaBaseCollectionView from "../InboomaBaseCollectionView";
import { Notification, Biscuit } from "../../utils";
import "../../../vendor/Blob";
import { getApiHost } from "../../Sync";
import PaginationBehavior from "../../behaviors/Behavior.Pagination";
import { getContentModifications } from "../../App";

import Reservation from "../../models/Reservation";
import OrdersItemTpl from "../../templates/orders/OrdersItemTpl.html";
import * as FileSaver from "../../../vendor/FileSaver";
import { getDocHandler } from "../../utils/Helper";
import t from "../../react/helpers/t";

// @todo Split parts of OrdersItemView into lazily rendered component
// "OrdersItemReservationsList" for more SOC and performance increase

const OrdersItemView = InboomaBaseView.extend({
  template: OrdersItemTpl,
  className: "inb-c-item inb-c-item--order row",

  ui: {
    dropdown: ".inb-dropdown",
    orderEdit: ".inb-order__edit",
    orderPriceTooltip: ".inb-order-price__tooltip",
  },

  events: {
    "change .inb-order--status .inb-status-select": "_orderStatusChanged",
    "change .inb-reservation .inb-status-select": "_reservationStatusChanged",
    "click .inb-toggle-details": "_toggleReservations",
    "click .inb-reservation__pdf": "_printRentalContract",
    "click .inb-toggle-order-dd": "_initDropdown",
    "click .inb-c-item-show-form-data": "_showPopUp",
    "click .print-form-data": "_printFormData",
  },

  modelEvents: {
    changed: "render",
    destroy: "remove",
    "change:status": "_statusChanged",
  },

  templateContext() {
    if (this.model.get("timespan_begin") == "" && this.model.get("reservations").length) {
      // @todo Is this only called once per instance?
      this.model.setTimespan(); // re-calculate start & end from reservations
    }

    return {
      _,
      moment,
      Biscuit,
      begin: this.model.get("timespan_begin") !== "" ? this.model.get("timespan_begin") : "",
      end: this.model.get("timespan_end") !== "" ? this.model.get("timespan_end") : "",
      app_user_role: Biscuit.get("user.role"),
      locations: this.options.locations,
      api_host: getApiHost().replace(".net/api", ".net"),
      i18n_payment_type: {
        1: this.t("cash", null, "capital"),
        2: this.t("credit_card", null, "capital"),
        3: this.t("sepa", null, "capital"),
      },
      client_currency: Biscuit.get("client.currency"),
      /*'i18n_payment_status' : {
              1 : this.t('pending'),
              2 : this.t('paid'),
              3 : this.t('payout'),
              4 : this.t('refund'),
              5 : 'Error'
            }*/
      i18n_payment_status: {
        1: this.t("pending"),
        PAID: this.t("paid"),
        3: this.t("payout"),
        4: this.t("refund"),
        ERROR: "Error",
      },
      hasCheckins: false,
      hasCompletedCheckouts: false,
      printContingentsAmountList: Reservation.prototype.printContingentsAmountList,
      _exchangeLabel: (value) => {
        let cm = getContentModifications();

        if (cm.labels != null) {
          if (cm.labels[value] !== undefined) {
            return cm.labels[value];
          }
        }
        return value;
      },
      getOrderUsername: (user) => {
        if (
          (user.first_name === undefined || user.first_name == null || user.first_name == "") &&
          (user.last_name === undefined || user.last_name == null || user.last_name == "")
        ) {
          return user.customer_nbr;
        }
        return user.first_name + " " + user.last_name;
      },
    };
  },

  onBeforeRender() {
    if (this._renderToggled || this.options.toggleOrderById == this.model.get("id")) {
      this._renderToggled = true;
      this.$el.addClass("toggled");
    }

    if (this.model.get("status") === "cancelled") {
      this.$el.addClass("is-cancelled");
    }

    if (this.model.get("tag_list") !== null && this.model.get("tag_list") != "") {
      let tags = this.model.get("tag_list").split(",");
      let hasFormData = false,
        hasTour = false;
      _.each(tags, function (val, k) {
        if (val.trim() === "Anlieferungen") {
          hasFormData = true;
        }
        if (val.trim() === "Tour") {
          hasTour = true;
        }
      });
      if (hasFormData) {
        this.$el.addClass("has-form-data");
      }
      if (hasTour) {
        this.$el.addClass("has-tour");
      }
    }
    if (this.model.get("types") === "service") {
      this.$el.addClass("is-service");
    }
  },

  /** Status of order model has been changed by this OR any other view
   * -> update only visualization of order status
   * anything else is done by the model itself or the view that causes the status change
   */
  _statusChanged() {
    this.$el.removeClass("is-cancelled");

    if (this.model.get("status") === "cancelled") {
      this.$el.addClass("is-cancelled");
    }

    this.render();
  },

  _initDropdown(ev) {
    ev.preventDefault();

    const priceTooltip = this.getUI("orderPriceTooltip");

    //if (typeof this._dropdown === 'undefined') {
    this._dropdown = new Foundation.Dropdown(this.getUI("dropdown"));
    //}

    this._dropdown.open();

    if (priceTooltip.length) {
      new Foundation.Tooltip(priceTooltip);
    }

    return false;
  },

  _toggleReservations(target) {
    let showWarning = false;

    const that = this;
    const t = $(target.currentTarget);

    // if any reservation has been modified after last order execute

    _.each(this.model.get("reservations").models, function (reservation) {
      if (
        moment(reservation.get("modified")).format("x") >
          moment(that.model.get("executed")).format("x") &&
        that.model.get("executed") != null
      ) {
        showWarning = true;
      }
    });

    if (this.model.get("status") != "confirmed" && this.model.get("status") != "paid") {
      showWarning = false;
    }

    if (showWarning) {
      t.closest(".inb-c-item").find(".off-canvas__form-error:first").removeClass(" hide");
    } else {
      t.closest(".inb-c-item").find(".off-canvas__form-error:first").addClass(" hide");
    }

    $("#" + $(target.currentTarget).attr("data-inb-toggle")).toggleClass("active");
    this.$el.toggleClass("toggled");
  },

  _printRentalContract(target) {
    // show warning if rental contract should be confirmed
    const that = this;

    let showWarning = false;

    _.each(this.model.get("reservations").models, function (reservation) {
      if (
        moment(reservation.get("modified")).format("x") >
          moment(that.model.get("executed")).format("x") &&
        that.model.get("executed") != null
      ) {
        // showWarning = true;
      }
    });

    // proof if status is executed or paid
    if (this.model.get("status") != "confirmed" && this.model.get("status") != "paid") {
      showWarning = false;
    }

    if (showWarning === true) {
      if (confirm(this.t("rental_contract_warning"))) {
        const t = $(target.currentTarget),
          rid = t.closest(".inb-reservation").attr("data-inb-reservation");

        let ref = "" + getApiHost();
        ref = ref.slice(0, -4) + "/rental_contract/" + rid;
        window.open(ref, "_blank");
      }
    } else {
      const t = $(target.currentTarget),
        rid = t.closest(".inb-reservation").attr("data-inb-reservation");

      /*let ref = "" + getApiHost();
        ref = ref.slice(0, -4) + "/rental_contract/" + rid;
        window.open(ref,'_blank');*/
        getDocHandler('/rental_contract/' + rid,'GET','application/pdf',t('reservation')+'-'+reservation.order.order_nbr+'.pdf','',rid);
    }

    // Request rental contract as PDF from backend, then trigger download dialogue to browser
    /*
      const t = $(target.currentTarget),
            rid = t.closest('.inb-reservation').attr('data-inb-reservation');

      // FileSaver bereits oben importiert

      // Fallback on native ajax request as more flexible when setting certain parameters
      const xmlHttp = new XMLHttpRequest();

      xmlHttp.open("GET", getApiHost() + '/reservations/getRentalContract/' + rid, true);

      xmlHttp.setRequestHeader('Accept', 'application/json')
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
      xmlHttp.responseType = "blob";
      xmlHttp.onload = function() {

        if (xmlHttp.status === 500) {
          alert('mietvertrag_download_error')
          return;
        }

        const blob = new Blob([xmlHttp.response], { type: 'application/pdf' });

        FileSaver.saveAs(blob, "rental_contract_"+ rid +".pdf");

      };

      xmlHttp.send(null);
      */
  },

  _showPopUp(ev) {
    ev.stopImmediatePropagation();
    const that = this;
    let output = `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>${that.t("form_data")}</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>${this.model.get("form_data")}
          
            </body>
            </html>`;
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
      var uA = navigator.userAgent;
      var rE = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");

      if (rE.exec(uA) != null) {
        rV = parseFloat(RegExp.$1);
      } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        rV = 11;
      }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const newWindow = window.open("", "", "height=700,width=674");

    newWindow.document.body.innerHTML = "";
    newWindow.document.body.innerHTML = output;
    if (rV >= 10 || isChrome) {
      newWindow.focus(); // necessary for IE >= 10*
    } else {
      // e.g. Firefox
      setTimeout(() => {
        newWindow.opener.focus();
      }, 0);
    }
    return true;
  },

  /**
   * Status of order model has been changed by this view.
   *  -> sync with backend, show individual notifications
   * @todo Merge with _statusChanged
   */
  _orderStatusChanged(target) {
    target.stopImmediatePropagation();

    const that = this,
      t = $(target.currentTarget),
      val = t.val();

    if (val !== "") {
      if (t.closest(".inb-before-badge").length >= 1) {
        t.closest(".inb-before-badge").attr("data-inb-status", val);
      }

      this.model.save(
        { status: val },
        {
          patch: true,
          silent: true,
          success() {
            that._statusChanged();

            if (val === "cancelled") {
              new Notification({
                message: that.t(
                  that.model.get("wallet_transactions").length === 0
                    ? "order_cancelled_success"
                    : "order_cancelled_success_transactions"
                ),
                duration: 9000,
                type: "success",
                closeable: true,
                icon: "fi fi-loop",
              });
            } else {
              new Notification({
                message: that.t("updated_${a}", { a: that.t("order") }, "capital"),
                duration: 5000,
                type: "success",
                closeable: true,
                icon: "fi fi-check",
              });
            }

            that.model.updatePrice(function () {
              that._renderToggled = true;
              that.render();
            });
          },
        }
      );
    } else {
      // action aborted -> reset selectbox
      for (var i = 0; i < target.currentTarget.options.length; i++) {
        if (target.currentTarget.options[i].value == this.model.get("status")) {
          target.currentTarget.selectedIndex = i; // reset selectbox
          return;
        }
      }
    }
  },

  _reservationStatusChanged(target) {
    target.stopImmediatePropagation(); // stop any further handling of the event

    const that = this,
      t = $(target.currentTarget),
      rid = t.closest(".inb-reservation").attr("data-inb-reservation"),
      val = t.val();

    if (val !== "") {
      console.log("I", this.model.get("reservations"));

      this.model
        .get("reservations")
        .get(rid)
        .save(
          { status: val },
          {
            patch: true,
            success: () => {
              new Notification({
                message: that.t("updated_${a}", { a: that.t("reservation") }, "capital"),
                duration: 5000,
                type: "success",
                closeable: true,
                icon: "fi fi-check",
              });

              that.model.updatePrice(function () {
                that._renderToggled = true;
                that.render();
              });
            },
          }
        );
    }
  },
});

export default InboomaBaseCollectionView.extend({
  childView: OrdersItemView,
  template: _.noop,

  childViewOptions() {
    return {
      toggleOrderById: this.getOption("toggleId"),
      locations: this._locations,
    };
  },

  behaviors: [
    {
      behaviorClass: PaginationBehavior,
    },
  ],

  initialize() {
    // Init utils here once and pass down to model templates
    this._locations = Radio.channel("locationsWithTrashed").request("get:data");

    InboomaBaseCollectionView.prototype.initialize.apply(this);

    if (!this.options.widgetMode) {
      this.$el.html("");
    }

    this.render();
  },

  onRender() {
    // @todo Un-JQuerify...
    $(".inb-c-loader").hide();

    if ($(".inb-c-item.toggled").length >= 1) {
      $("html,body").scrollTop($(".inb-c-item.toggled").offset().top - 10);
    }
  },
});
